// 签收管理
import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 签收状态 客户端发起（1.0.3
 * 待确认 待签署 待发起 都是查询枚举（即不会返回）
 */
class ReceiveState extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    TO_BE_INITIATE = new Meta(8, "待发起");
    TO_BE_SIGNED = new Meta(7, "待签署");
    SIGNING = new Meta(3, "签署中");
    TO_BE_CONFIRMED = new Meta(6, "待确认");
    CONFIRMING = new Meta(4, "确认中");
    REVERTED = new Meta(2, "已驳回");
    FINISHED = new Meta(5, "签收完成");
    INVALIDING = new Meta(9, "作废中");
    INVALID = new Meta(10, "已作废");
}
export const RECEIVE_STATE = new ReceiveState();

/**
 * 查条件显示
 */
class SaleReceiveState extends UltMeta {
    TO_BE_SIGNED = new Meta(7, "待签署");
    TO_BE_CONFIRMED = new Meta(6, "待确认");
    SIGNING = new Meta(3, "签署中");
    FINISHED = new Meta(5, "签收完成");
    INVALIDING = new Meta(9, "作废中");
    INVALID = new Meta(10, "已作废");
}

export const SALE_RECEIVE_STATE = new SaleReceiveState();

// 签收状态 线下 管理端发起
class AdminOfflineReceiveState extends UltMeta {
    TO_BE_CONFIRMED = new Meta(4, "待确认");
    FINISHED = new Meta(5, "签收完成");
}

export const ADMIN_OFFLINE_RECEIVE_STATE = new AdminOfflineReceiveState();

// 销售签收 状态 管理端发起
class AdminReceiveState extends UltMeta {
    TO_BE_SIGNED = new Meta(3, "待签署");
    SIGNING = new Meta(2, "签署中");
    FINISHED = new Meta(5, "签收完成");
}

export const ADMIN_RECEIVE_STATE = new AdminReceiveState();

// 采购签收 状态 管理端发起
class AdminPurchasingReceiveState extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    TO_BE_INITIATE = new Meta(8, "待发起");
    TO_BE_SIGNED = new Meta(7, "待签署");
    SIGNING = new Meta(3, "签署中");
    FINISHED = new Meta(5, "签收完成");
}

export const ADMIN_PURCHASING_RECEIVE_STATE = new AdminPurchasingReceiveState();

// 采购签收状态 线下 用户端发起
class AdminPurchasingOfflineReceiveState extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    TO_BE_CONFIRMED = new Meta(4, "确认中");
    FINISHED = new Meta(5, "签收完成");
}

export const ADMIN_PURCHASING_OFFLINE_RECEIVE_STATE = new AdminPurchasingOfflineReceiveState();

// 签收状态 线下 用户端发起
class CustomOfflineReceiveState extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    TO_BE_CONFIRMED = new Meta(4, "确认中");
    FINISHED = new Meta(5, "签收完成");
}

export const CUSTOM_OFFLINE_RECEIVE_STATE = new CustomOfflineReceiveState();

// 签收状态 线上 用户端发起
class CustomReceiveState extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    TO_BE_SIGNED = new Meta(7, "待签署");
    SIGNING = new Meta(3, "签署中");
    FINISHED = new Meta(5, "签收完成");
}

export const CUSTOM_RECEIVE_STATE = new CustomReceiveState();

// 签收-结算状态
class ReceiveReconciliationState extends UltMeta {
    NOT_RECONCILIATION = new Meta(0, "未结算", "color-black");
    RECONCILING = new Meta(1, "结算中", "color-black");
    RECONCILED = new Meta(2, "已结算", "color-info");
    INVALID = new Meta(3, "作废中", "color-info");
}
export const RECEIVE_RECONCILIATION_STATE = new ReceiveReconciliationState();
